import { BaseButton, type BaseButtonProps } from '@/components/common/base-button';
import clsx from 'clsx';
import styles from './styles.module.scss';
import { useRef } from 'react';

type Props = Omit<BaseButtonProps, 'isSelected' | 'icon' | 'fullWidth' | 'fullHeight'> & {
    isSelected?: boolean;
    icon?: React.ReactNode;
    fullWidth?: boolean;
    fullHeight?: boolean;
};
export const CategoryButton = ({ children, isSelected, icon, fullWidth = false, fullHeight = false, onClick, ...props }: Props) => {
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    const handleClickButton = (event: React.MouseEvent<HTMLButtonElement>) => {
        const target = event.currentTarget;
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        target.classList.add('button-light__active');
        timeoutRef.current = setTimeout(() => {
            target.classList.remove('button-light__active');
            onClick?.(event);
        }, 600);
    };
    return (
        <BaseButton
            {...props}
            onClick={handleClickButton}
            className={clsx('button-light', styles['category-button'], {
                [styles['category-button--selected']]: isSelected,
                [styles['category-button--full-width']]: fullWidth,
                [styles['category-button--full-height']]: fullHeight,
            })}
        >
            <span className={styles['category-button__icon']}>{icon}</span>
            <span className={styles['category-button__text']}>{children}</span>
        </BaseButton>
    );
};
